import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import Form from "src/components/Form"

import { formatInvoiceDate } from "./copy"

const InvoicesTable = ({
  lines,
  copy,
  formatMoney,
  failure,
  viewPaymentLabel,
}) => (
  // Clip, not hidden: a hidden overflow would make this box the sticky
  // header's scroll container instead of the dialog's scroll area.
  <div className="overflow-clip rounded-lg border">
    <table className="w-full table-fixed text-left text-gray-900">
      <thead className="sticky top-0 bg-gray-200">
        <tr className="h-10 whitespace-nowrap">
          <th className="w-52 px-4 font-semibold">{copy.invoice}</th>
          <th className="px-4 text-right font-semibold">{copy.amountDue}</th>
          <th className="px-4 text-right font-semibold">{copy.applying}</th>
          <th className="w-32 px-4 text-right font-semibold">
            {copy.newBalance}
          </th>
        </tr>
      </thead>
      <tbody>
        {lines.map((line) => (
          <tr
            key={line.invoiceId}
            className={classNames("h-16 border-t align-middle", {
              "bg-red-50": failure?.invoiceId === line.invoiceId,
            })}
          >
            <td className="px-4 py-2.5">
              <div className="truncate font-semibold">{line.invoiceId}</div>
              <div>
                {line.sourceType}
                {line.dueDate && (
                  <span className="text-gray-600">
                    {line.sourceType && " · "}
                    {formatInvoiceDate(line.dueDate)}
                  </span>
                )}
              </div>
              {failure?.invoiceId === line.invoiceId && (
                <div className="mt-1 whitespace-normal">
                  <Form.Error>{failure.message}</Form.Error>
                  {failure.paymentPath && (
                    <a href={failure.paymentPath}>{viewPaymentLabel}</a>
                  )}
                </div>
              )}
            </td>
            <td className="px-4 py-2.5 text-right">
              {formatMoney(line.balanceCents)}
            </td>
            <td className="px-4 py-2.5 text-right">
              {formatMoney(line.balanceCents)}
            </td>
            <td className="px-4 py-2.5 text-right">
              <div className="leading-[16px]">{formatMoney(0)}</div>
              <div className="mt-1 text-xs font-semibold text-teal-600">
                {copy.paysInFull}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

InvoicesTable.propTypes = {
  lines: PropTypes.arrayOf(
    PropTypes.shape({
      invoiceId: PropTypes.string.isRequired,
      balanceCents: PropTypes.number.isRequired,
      sourceType: PropTypes.string,
      dueDate: PropTypes.string,
    })
  ).isRequired,
  copy: PropTypes.shape({
    invoice: PropTypes.string.isRequired,
    amountDue: PropTypes.string.isRequired,
    applying: PropTypes.string.isRequired,
    newBalance: PropTypes.string.isRequired,
    paysInFull: PropTypes.string.isRequired,
  }).isRequired,
  formatMoney: PropTypes.func.isRequired,
  failure: PropTypes.shape({
    invoiceId: PropTypes.string,
    message: PropTypes.string.isRequired,
    paymentPath: PropTypes.string,
  }),
  viewPaymentLabel: PropTypes.string.isRequired,
}

export default InvoicesTable
